// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import store from '../src/store'

import 'element-ui/lib/theme-chalk/index.css'
import './assets/styles/common.css'

// iconfont字体图标库
import './assets/fonts/iconfont/iconfont.css'
Vue.use(ElementUI, { size: 'small' })
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  router,
  store,
  template: '<App/>',
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js